import { render, staticRenderFns } from "./MerchantRedirectNotification.vue?vue&type=template&id=f31dd9ea&scoped=true"
import script from "./MerchantRedirectNotification.vue?vue&type=script&lang=ts"
export * from "./MerchantRedirectNotification.vue?vue&type=script&lang=ts"
import style0 from "./MerchantRedirectNotification.vue?vue&type=style&index=0&id=f31dd9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31dd9ea",
  null
  
)

export default component.exports